module.exports = __webpack_public_path__ + "img/rukavy_08_oranzova.5a3210ff.png";